export default {
    mapasCotacao: [],
    mapaCotacao: {},
    produtosPreSelecionadosNovoMapa: [],
    ultimaAtualizacaoListaMapa: Date
}
